/**
 * Provena Studio, l'outil de travail des ateliers (RDEC-023). Registry y
 * renvoie l'atelier depuis l'accueil, la page « Professionnels » et le pied
 * de page ; une seule adresse pour les trois.
 */
export const STUDIO_URL = "https://provena.studio";
